import React from "react";
import dayjs from 'dayjs';
import isBetweenPlugin from 'dayjs/plugin/isBetween';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import DOMPurify from 'dompurify';
import DataTable from "react-data-table-component";
import { downloadColumns } from "./DownloadColumns";
import { useState, useEffect } from "react";
import {
  Box,
  MenuItem,
  Select,
  FormControl,
  Button,
  Grid,
  Divider,
  Stack
} from "@mui/material";
import "../../listings/Listing.css";
import {
  getAllowanceUpdateList,
  getResidentStatusUpdateList,
  downloadResidentStatusList,
  downloadAllowanceUpdateList
} from "../../common/constants/globalconstants";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";
import ErrorModal from "../../common/ErrorModal";
import { DatePicker } from "@mui/x-date-pickers";
import axiosInstance from "../../common/AxiosInterceptor";

dayjs.extend(isBetweenPlugin);

const customStyle = {
	table: {
	  style: {
		border: "1px solid #DEDEDE",
		borderRadius: "5px",
		justifyContent: "center",
		marginBottom: "10px",
		marginTop: "10px",
	  },
	},
	header: {
	  style: {
		color: "#193062",
	  },
	},
	headRow: {
	  style: {
		border: "none",
		backgroundColor: "#CDD4DC",
		fontWeight: "bold",
		color: "#002d82",
		fontSize: "14px",
		whiteSpace: "unset",
	  },
	},
	rows: {
	  stripedStyle: {
		backgroundColor: "#F2F3F5",
		justifyContent: "center",
	  },
	},
  }; 
  

function Download() {
  const [tableData, setTableData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [loading, setloading] = useState(false); 
  const [response, setResponse]= useState([]);
  const [errormodalopen, seterrormodalOpen]= useState(false);
  const [openModal, setOpenModal]= useState(false);
  const [rowData, setRowData]= useState({});
  const [isErr, setIsErr] =useState(false);
  const [frmDtErr, setFrmDtErr] = useState("");
  const [weekStartDate, setweekStartDate] =useState("");
  const [weekEndDate, setWeekEndDate] =useState("");
  const [action, setAction] =useState('');
  const [searchField, setSearchField] =useState("");
  const [searching, setSearching] = useState(false);
  const [resetPagination, setRstPagination] = useState(false);
  const [tableKey, setTableKey] = useState(0);
  const [reportType, setReportType] = useState("allowanceUpdate");
  const [disableDownloadAll, setDisableDwnldAll] = useState(true);
  
  //const storetoken = useSelector((state) => state.storetoken);

  useEffect(()=>{
    getInitialListing(reportType);  
  },[]);


   const getFormattedDate =(inputDate)=>{
    const date =new Date(inputDate);
    const month = String(date.getUTCMonth()+1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');
    const year = date.getUTCFullYear();
   
    return `${month}-${day}-${year}`;
  }

  const createInputRequest=()=>{
    return {
      "startDate": weekStartDate ? getFormattedDate(weekStartDate): "",
      "endDate": weekEndDate ? getFormattedDate(weekEndDate): "",
    }
  }

  const getInitialListing = (type) =>{
    const inputRequest= createInputRequest();   
    getApiResponse(inputRequest, type);
  }

  const getApiResponse =async(inputRequest, type)=>{
	let response =[];
    try {
      setloading(true);
	  if(type === "residentStatusUpdate"){
		response = await axiosInstance.post(`${getResidentStatusUpdateList}`,
			JSON.stringify(inputRequest));
	  }
	  else {
		response = await axiosInstance.post(`${getAllowanceUpdateList}`,
			JSON.stringify(inputRequest));
	  }      
        if(response.data.isSuccess){
		   setResponse(response.data.result);
           setTableData(response.data.result);
		   setOriginalData(response.data.result);
		   setTableKey(prevKey=> prevKey+1);
           seterrormodalOpen(false);
		   setWeekEndDate((response.data.result.length !== 0 && dayjs(response.data.result[0].endDate)) || weekEndDate);
		   setweekStartDate((response.data.result.length !== 0 && dayjs(response.data.result[response.data.result.length-1].startDate)) || weekStartDate);
		   for(const record of response.data.result){
			if(record.recordCount !=="0"){
				setDisableDwnldAll(false);
				break;
			}else{
				setDisableDwnldAll(true);
			}
		   }	   
        }
        else if(!response.data.isSuccess){
          seterrormodalOpen(true);
        }
        setloading(false);
    } catch (error) {
      console.log(error.message);
      seterrormodalOpen(true);
      setloading(false);
    }
  }

  const handleChange=(e)=>{
    setReportType(e.target.value);
	getInitialListing(e.target.value);
  }

  const handleRowClick = (row) => {
    setRowData(row);
    setOpenModal(true);    
  };

  const validateRequest =() =>{
    let isError=false;
	if((weekStartDate ==="" || weekStartDate=== undefined || weekStartDate === null) &&
	 (weekEndDate === "" || weekEndDate === undefined || weekEndDate ===null)){
		setFrmDtErr("Please select Week Start Date & Week End Date");
        setIsErr(true);
        isError =true;
	 }
      else if(weekEndDate !=="" && weekEndDate!==undefined && weekEndDate!==null && (weekStartDate === "" || weekStartDate===undefined || weekStartDate===null)){
        setFrmDtErr("Week Start Date can not be blank");
        setIsErr(true);
        isError =true;
      }
	  else if(weekStartDate!=="" && weekEndDate!=="" && weekStartDate> weekEndDate){
		setFrmDtErr("Week Start Date should be less than Week End Date");
		setIsErr(true);
        isError =true;
	  }
	  else{
        setFrmDtErr("");
        setIsErr(false);
        isError =false;
      }
    return isError;
  }

  const handleSearchClick=()=>{  
	setRstPagination(!resetPagination);
	setSearching(false);
    const err = validateRequest();
    if(!err){ 
		getInitialListing(reportType);
	  	setSearchField("");
    }    
  }

  const handleResetClick=()=>{      
      setAction("");
      setIsErr("");
	  setSearchField("");
	  setRstPagination(!resetPagination);
	  setReportType("allowanceUpdate");
	  const inputRequest= {
		"startDate":"",
		"endDate":""
	  }  
	  getApiResponse(inputRequest, "allowanceUpdate");
	  setTableKey(prevKey =>prevKey+1);
  }

  const handleDownloadAllClick =() =>{
	const length = response && response.length;
	const request = {
		"startDate": response ? getFormattedDate(response[length-1].startDate): "",
      	"endDate": response ? getFormattedDate(response[0].endDate): "",
	}
	getDownloadContent(request);
  }

  const handleDownlodLinkClick=(row, props, type)=>{
	const request = {
		"startDate": row && row.startDate ? getFormattedDate(row.startDate): "",
      	"endDate": row && row.endDate ? getFormattedDate(row.endDate): "",
	}
	getDownloadContent(request, row);
  }

  const getDownloadContent= async(request, row) =>{
	let response =[];
    try {
      setloading(true);
	  if(reportType === "residentStatusUpdate"){
		response = await axiosInstance.post(`${downloadResidentStatusList}`,
			JSON.stringify(request));
	  }
	  else {
		response = await axiosInstance.post(`${downloadAllowanceUpdateList}`,
			JSON.stringify(request));
	  }    
        if(response.data){
			const contentType = response.headers['content-type'];
			const blob = new Blob([response.data], { type: contentType });
			const url = window.URL.createObjectURL(blob);
			const link = document.createElement('a');

			const safeUrl = DOMPurify.sanitize(url);
			link.href = safeUrl;
			if(reportType == "allowanceUpdate"){
				if(row){
					let startDt=(row.startDate).split("-").join("");
					let endDt=(row.endDate).split("-").join("");
					link.setAttribute('download', startDt+"_"+endDt+"_AllowanceUpdateListing.txt"); // Replace with desired filename
				}
				else{
					link.setAttribute('download', getFormattedDate(weekStartDate).split("-").join("")+"_"+getFormattedDate(weekEndDate).split("-").join("")+"_AllowanceUpdateListing.txt"); // Replace with desired filename
				}
				
			}
			else{
				if(row){
					link.setAttribute('download', row.startDate.split("-").join("")+"_"+row.endDate.split("-").join("")+'_ResidentStatusListing.txt'); // Replace with desired filename
				}
				else {
					link.setAttribute('download', getFormattedDate(weekStartDate).split("-").join("")+"_"+getFormattedDate(weekEndDate).split("-").join("")+'_ResidentStatusListing.txt'); // Replace with desired filename
				}
			}
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
        }
        else if(!response.data.isSuccess){
          seterrormodalOpen(true);
        }
        setloading(false);
    } catch (error) {
      console.log(error.message);
      seterrormodalOpen(true);
      setloading(false);
    }
  }

  const isSunday = (date) => dayjs(date).day() === 0;
  const isSaturday = (date) => dayjs(date).day() === 6;

	  return (
		<div>
		  {loading && (
			<>
			  <Backdrop
				sx={{ color: "white", zIndex: (theme) => theme.zIndex.drawer + 1 }}
				open={true}
			  >
				<CircularProgress sx={{ color: "white" }} />
				<span> &nbsp;&nbsp;&nbsp;&nbsp; Loading Data... </span>
			  </Backdrop>
			</>
		  )}
	
		<div>
		  <Box
        sx={{
          position: "relative",
          alignContent:"center",
          justifyContent: "center",
          left: "2%",
		  right: "2%",
          flexDirection: "column",
          width: "95%",
          marginTop: "10px",
          marginBottom: "10px",
          alignItems: "center",
          p: "0% 1%",
          backgroundColor: "#fcfcfc",
          //border: "2px solid #dfe3e8",
          borderRadius: "20px",
        }}
      >
		  <h2 className="header">Download Reports</h2>
		  
		  <Box
		  sx={{
			justifyContent:"center",
			alignContent:"center",
			alignItems:"center",
			display:"flex",
			width:"100%",
			height:"30px"
		  }}>
		  <p style={{color:"red", marginTop:"4px"}}>{isErr && frmDtErr? frmDtErr:""}</p>
		  </Box>
			<div
			  style={{
				display: "flex",
				flexDirection: "row",
			  }}
			>  
		  <Grid container> 
		  <div style={{marginTop: "5px", width:"98%"}}>  
		            
				  <Box
				  sx={{
					border:"1px solid #002d82",
					position:"relative",
					display:"inline-block",
					barderRadius:"5px",
					width: "100%",
					padding:"10px",
					marginRight:"10px",
					height:"120px",
					marginBottom:"20px"
				  }}>
					<Box
					  //display="flex"
					  direction="row"
					  alignItems="left"
					  justifyContent="left"
					  alignContent="left"
					  columnGap="1rem"
					  marginTop="5px"
					  sx={{ width:"100%", height: "50px", m: "3px 0"  }} 
				  >
					<Stack
						direction="row"
						alignItems="center"
						justifyContent="space-between"
						sx={{ width: "100%", height: "40px", mb: "5px", marginTop:"20px" }}
						> 
					<Grid xs={4}>
				  <Box
					display="flex"
					sx={{
					  flexDirection: "row",
					  alignItems: "center",
					  justifyContent: "center",
					  alignContent: "center",
					  height: "50px",
					  fontSize: "15px"
					}}
				  > 
				   <p style={{width: "120px", color: "black",fontWeight: "600", marginLeft:"5px"}}>
					Report Type:</p>
				 
				 		<FormControl variant="outlined" fullWidth margin="normal" size='small' style={{width:"240px", marginBottom:"20px", marginRight:"5px"}}>
								<Select							
								name="reportType"
								value={reportType}
								onChange={handleChange}
								>								 
								<MenuItem value="allowanceUpdate">Allowance Update Listing</MenuItem>
								<MenuItem value="residentStatusUpdate">Resident Status Listing</MenuItem>
								</Select>                    
						</FormControl>
				 </Box>
				 	</Grid>
				<Grid xs={4}>
				  <Box
					display="flex"
					sx={{
					  flexDirection: "row",
					  alignItems: "center",
					  justifyContent: "center",
					  alignContent: "center",
					  height: "50px",
					  fontSize: "15px"
					}}
				  > 
				  
					<p style={{width: "140px", color: "black",fontWeight: "600", marginLeft:"5px"}}>
					Week Start Date:</p>
					<LocalizationProvider dateAdapter={AdapterDayjs}>
					<DatePicker
					className="report-to-datePicker"
					sx={{ ml: "0px", width: "200px", marginBottom:"30px", marginRight:"10px", "& .MuiInputBase-input":{ height: "7px !important"} }}
					name="weekStartDate"
					onChange={(newValue)=> 
						setweekStartDate(dayjs(newValue))
				  }
				  value={weekStartDate}
				  size="small"
				  disableOpenOnEnter
				  shouldDisableDate={(date)=>!isSunday(date)}
					slotProps={{ textField: {
						readOnly: true,
						},
					}}
				  displayWeekNumber
				  >               
				  </DatePicker>	
				  </LocalizationProvider>		  
				 </Box>
				 </Grid>
				 <Grid xs={4}>
				  <Box
					display="flex"
					sx={{
					  flexDirection: "row",
					  alignItems: "center",
					  justifyContent: "center",
					  alignContent: "center",
					  height: "50px",
					  fontSize: "15px"
	  
					}}
				  > 
				  <p style={{width: "140px", color: "black",fontWeight: "600"}}>
							Week End Date:</p>
							<DatePicker
								className="report-to-datePicker"
								sx={{ ml: "0px", width: "200px", marginBottom:"30px", marginRight:"10px", "& .MuiInputBase-input":{ height: "7px !important"} }}
								inputFormat="MM DD YYYY"
								name="weekEndDate"							
								value={weekEndDate}
								size="small"
								shouldDisableDate={(date)=>!isSaturday(date)}
								slotProps={{ textField: {
									readOnly: true,
									},
								}}
								displayWeekNumber
								onKeyDown={(e)=>e.preventDefault()}
								onKeyUp={(e)=>e.preventDefault()}
								onChange={(newValue)=> 
								setWeekEndDate(dayjs(newValue))
							}							
							>
							</DatePicker>
				  
				  </Box> 
				  </Grid>				  
					</Stack>
					<Stack
						direction="row"
						alignItems="center"
						justifyContent="space-between"
						marginTop="20px"
						sx={{ width: "100%", height: "40px", mb: "5px" }}
						> 
					<Grid xs={3}></Grid>
					<Grid xs={6}>
				  <Box
					display="flex"
					sx={{
					  flexDirection: "row",
					  alignItems: "center",
					  justifyContent: "center",
					  alignContent: "center",
					  height: "50px",
					  fontSize: "15px",
					  columnGap: "1rem"
					}}
				  > 
				  <Button
					variant="contained"
					style={{ backgroundColor:"#002d82",width: "120px", height:"35px", marginBottom:"6px", marginLeft: "0.5rem"}}
					onClick={handleSearchClick}
					>
					Search
					</Button>

					<Button
					variant="contained"
					style={{ backgroundColor:"#002d82",width: "120px", height:"35px", marginBottom:"6px"}}
					onClick={handleResetClick}
					>
					Reset
					</Button> 

					<Button
					variant="contained"
					disabled={disableDownloadAll}
					style={ !disableDownloadAll ? 
						 { backgroundColor:"#002d82",
					 	width: "150px",height:"35px", marginBottom:"6px"}
						: { backgroundColor:"#d3d3d3",
					 	width: "150px",height:"35px",marginBottom:"6px"}}
					onClick={handleDownloadAllClick}
					>
					Download All
					</Button>					
				  
				  </Box> 
				  </Grid>
				  <Grid xs={3}></Grid>
					</Stack>
				  </Box> 
					  
				  <Box
				  component="span"
				  sx={{ 
					position: "absolute",
					top: "-12px",
					left:"15px",
					//transform:"translateX(-50%)",
					backgroundColor: "white",
					padding: "0 10px",
					fontSize:"14px",
					whiteSpace:"nowrap"
					}}
					  >
					   Filter Criteria:   
							
				  </Box>
				  </Box>
		  </div>
		  </Grid>    
		  </div> 
		  
			<DataTable
			  title=""
			  key={tableKey}
			  columns={downloadColumns(handleDownlodLinkClick)}
			  data={response}
			  pagination
			  striped
			  highlightOnHover
			  customStyles={customStyle}
			  defaultSortFieldId={null}
			  defaultSortAsc={null}
			  paginationRowsPerPageOptions={[5, 10, 15, 20]}
			  paginationResetDefaultPage={resetPagination}
			  paginationPerPage={5}
			  paginationComponentOptions={{
				rowsPerPageText: "Records per page",
				rangeSeparatorText: "Out of",
			  }}
			  onRowClicked={handleRowClick}
			/>
			</Box>
		  </div>
		  {errormodalopen && (
			<ErrorModal open={true} onClose={() => seterrormodalOpen(false)} />
		  )}	
		 
		</div>
	  );
}


export default Download;
